import { useClerk } from "@clerk/clerk-react";
import { useMutation } from "convex/react";
import { api } from "../convex/_generated/api";
import { useContext } from "react";
import { BaseContext } from "./base-context";
import { MainRoutes } from "./models";
import { usePresence } from "./hooks/usePresence";

export const LogoutButton = () => {
  const { signOut } = useClerk();
  const { convexUserId } = useContext(BaseContext);
  const leavePresence = useMutation(api.presence.leave);
  const { deviceId } = usePresence();
  return (
    <button
      onClick={() => {
        leavePresence({ deviceId, page: MainRoutes.Chat, userId: convexUserId }).catch(() => {});
        signOut({ redirectUrl: window.location.origin });
      }}
      className="flex flex-row p-6 justify-center w-full font-bold"
    >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 mr-1">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
        </svg>
        Log out
    </button>
  );
}
